<soft-page>
  <soft-page-header [customClass]="'!p-0'">
    <div class="w-full mb-4">
      <soft-default-header
        [title]="steps[0].header | translate"
        [subtitle]="steps[0].subHeader | translate"
      />
      <soft-ds-progress-steps class="mx-2" [steps]="steps" [currentIndex]="0" />
    </div>
  </soft-page-header>

  <soft-lagerplatz-suche class="mt-4" (lagerplatzChange)="onLagerplatzSelected($event)" />
  @if (loading$ | async) {
  <soft-blocking-loading-spinner class="top-0 right-0" />
  }
</soft-page>
